export default "__VITE_ASSET__bfba5fe9__"